import type { PlenaryActivityInformation } from '@hendrx/lms/contracts/server';
import { useMemo } from 'react';

import { useLearningObjectCommonData } from 'shared/components/providers/LearningObjectCommonDataProvider';
import { useWorkMode } from 'shared/utils/useWorkMode';

import { useCourseContextData } from '../../components/providers/CourseContextProvider';

export const usePlenaryActivityInformation = () => {
  const { isPlayerAssignment } = useWorkMode();
  const { learningObjectDraftId, assignmentId } = useLearningObjectCommonData();
  const { courseCategoryId, courseDraftId, courseEnvironmentId } = useCourseContextData();

  return useMemo(
    () =>
      ({
        type: isPlayerAssignment ? 'assignment' : 'regular',
        id: (isPlayerAssignment ? assignmentId : learningObjectDraftId) ?? '',
        courseDraftId: courseDraftId ?? '',
        courseCategoryId: courseCategoryId ?? '',
        courseEnvironmentId: courseEnvironmentId ?? ''
      } satisfies PlenaryActivityInformation),
    [assignmentId, isPlayerAssignment, learningObjectDraftId, courseDraftId, courseCategoryId, courseEnvironmentId]
  );
};
